import React, { useState } from 'react';
import { ReactComponent as EventIcon } from 'assets/icons/event-icon.svg';
import { ReactComponent as GiftIcon } from 'assets/icons/gift-icon.svg';
import { ReactComponent as HelpIcon } from 'assets/icons/help-icon.svg';
import GiftAMemberModal from 'components/modals/gift-a-member-modal';
import FundWalletModal from 'components/modals/fund-wallet-modal';
import useDashboardContext from 'contexts/dashboard.context';
import BusinessCard from 'components/business-card';
import { isOnboardingCompleted } from 'utils/functions';

const BusinessCards = () => {
  const { members, onboarding } = useDashboardContext();
  const [showGiftMemberModal, setShowGiftMemberModal] = useState(false);
  const [showFundWalletModal, setShowFundWalletModal] = useState(false);

  const onboardingCompleted = isOnboardingCompleted(onboarding);

  const businessItems = [
    {
      icon: <EventIcon />,
      title: 'Host an event',
      description:
        'Plan and organize memorable company events effortlessly. Set budgets, invite team members, and manage RSVPs and expenses all in one place.',
      link: '/event-details',
      disabled: !onboardingCompleted
    },
    {
      icon: <GiftIcon className='text-[#E60A2B]' />,
      title: 'Gift a member',
      description:
        'Show your appreciation to employees on their special days. Choose from a selection of thoughtful gifts, and make their day brighter.',
      link: '',
      onclick: () => setShowGiftMemberModal(true),
      disabled: !onboardingCompleted || !members?.length
    },
    {
      icon: <HelpIcon />,
      title: 'Get Help',
      description:
        'Need assistance or have questions? Our support team is here to guide you through every step. Contact us for any inquiries or assistance you may require to make the most of Foodcourt Business',
      link: ''
    }
  ];

  return (
    <div className='w-full mt-6'>
      <p className='text-lg font-medium'>Do more with Foodcourt business🚀</p>

      <div className='flex flex-col sm:flex-row gap-3 lg:gap-4 my-4 justify-start w-full'>
        {businessItems.map((item, index) => {
          return <BusinessCard item={item} key={index} />;
        })}
      </div>

      <GiftAMemberModal
        isOpen={showGiftMemberModal}
        onClose={() => setShowGiftMemberModal(false)}
        setShowFundWalletModal={setShowFundWalletModal}
      />
      <FundWalletModal isOpen={showFundWalletModal} onClose={() => setShowFundWalletModal(false)} />
    </div>
  );
};

export default BusinessCards;
